<template>
  <div>
    <el-collapse @change="openCollapse" v-model="activeNames" :accordion="true">
      <el-collapse-item title="组件变量" name="1">
        <bindVariable :component="true" v-model="componentVariableProxy" :selectOption="getSelectOption()" />
      </el-collapse-item>
      <el-collapse-item title="鼠标事件" name="2">
        <cx-select :value.sync="eventNameProxy" :selectOptions="componentEventsSelectOptions" title="事件类型" />
      </el-collapse-item>
      <el-collapse-item title="数据事件" name="3">
        <cx-select :value.sync="eventNameProxy" :selectOptions="dataEventsSelectOptions" title="事件类型" />
        <div v-show="eventNameProxy === 'appointDataChange'">
        <el-radio-group
          class="mt16 variable_radio"
          v-model="variableTypeProxy"
        >
          <el-radio label="all">全部变量</el-radio>
          <el-radio label="appoint">指定变量</el-radio>
        </el-radio-group>
        <div class="variable_box mt8" v-if="variableTypeProxy === 'appoint'">
          <cx-check-box
            v-for="variable in componentVariableProxy"
            :key="variable.variableName"
            class="variable_item"
            @change="changeWatchVariable(variable.variableName, variable.variablePath, $event)"
            :value="variableTagProxy[variable.variableName] ? true : false"
            >{{ variable.variableName }}
          </cx-check-box>
          <div class="variable-watch-box" v-for="(item, k) in variableTagProxy" :key="k + 'Tag'">
            <div class="variable-watch_item">
              <p class="mt8">
                <span class="mr8">变量名</span> <span class="suffix_text">{{ k }}</span>
              </p>

              <div class="variable_item_triggerType mt8">
                <p class="mr8">触发模式</p>
                <el-switch
                  inactive-color="#409EFF"
                  style="width: 150px"
                  :width="40"
                  @change="changeTriggerMode(k, $event)"
                  :value="item.triggerType === 'exec'"
                  active-text="表达式"
                  inactive-text="变化时"
                >
                </el-switch>
              </div>
              <div class="variable_item_triggerType mt8" v-if="item.triggerType === 'exec'">
                <p class="mr8">{{ k }}</p>
                <div class="mr8" style="width: 85px">
                  <cx-select :value="item.matchType" @change="changeMatchType(k, $event)" :selectOptions="matchTypes" />
                </div>
                <el-input
                  v-model="item.matchStr"
                  @change="changeTriggerExec(k, $event)"
                  style="width: 180px"
                  placeholder="请输入表达式"
                >
                </el-input>
              </div>
            </div>
            <div class="select_box" v-if="item && checkName(k)">
              <p class="mt8 icon-portal-up_bold"></p>
              <cx-select
                class="select_box_content mt8"
                :value="item.mode"
                @change="changeVariableType(k, $event)"
                :selectOptions="triggerTypes"
              />
              <p class="mt8 icon-portal-down_bold"></p>
            </div>
          </div>
        </div>
        <div class="mt16 save_box padding0">
          <div @click="nextStep" class="save_edit">下一步</div>
        </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { allEventTypes } from "utils/event"
import bindVariable from "./bindVariable.vue"
import { allGetOptDesEv } from "./utils/getRectOptDes.js"
export default {
  components: {
    bindVariable
  },
  props: {
    eventName: String,
    componentVariables: Array,
    variableTag: Object,
    publishIds: Object
  },
  data() {
    return {
      value1: true,
      activeNames: [],
      componentEventsSelectOptions: allEventTypes.mouseEventsTypes,
      dataEventsSelectOptions: allEventTypes.dataEventsTypes,
      variableTagProxy: {},
      triggerTypes: [
        {
          label: "且",
          value: "&&"
        },
        {
          label: "或",
          value: "||"
        }
      ],
      matchTypes: [
        {
          label: "===",
          value: "==="
        },
        {
          label: ">",
          value: ">"
        },
        {
          label: "<",
          value: "<"
        },
        {
          label: ">=",
          value: ">="
        },
        {
          label: "<=",
          value: "<="
        },
        {
          label: "!==",
          value: "!=="
        }
      ],
      variableType: "all",
      changeEventNameTag: false
    }
  },
  methods: {
    getSelectOption() {
      const rectAttr = this.getAttrById(this.$store.state[this.request_prefix], this.publishIds)
      const opt = rectAttr.options ? rectAttr.options : rectAttr
      const shape = opt.innerElement
      return allGetOptDesEv[`get${shape[0].toUpperCase() + shape.slice(1)}OptDes`](opt)
    },
    checkName(name) {
      const keys = Object.keys(this.variableTagProxy)
      return keys.findIndex(k => k === name) !== keys.length - 1
    },
    openCollapse() {
      this.$emit("update:eventName", "")
    },
    nextStep() {
      this.$emit("update:variableTag", JSON.parse(JSON.stringify(this.variableTagProxy)))
      console.log(this.variableTagProxy)
      this.$emit("next")
    },
    changeVariableType(name, val) {
      this.$set(this.variableTagProxy[name], "mode", val)
    },
    changeMatchType(name, val) {
      this.$set(this.variableTagProxy[name], "matchType", val)
    },
    changeTriggerMode(name, val) {
      if (val) {
        this.$set(this.variableTagProxy[name], "triggerType", "exec")
        this.$set(this.variableTagProxy[name], "matchType", "===")
        this.$set(this.variableTagProxy[name], "matchStr", "")
      } else {
        this.$set(this.variableTagProxy[name], "triggerType", "change")
        this.$delete(this.variableTagProxy[name], "matchType")
        this.$delete(this.variableTagProxy[name], "matchStr")
      }
    },
    changeTriggerExec(name, val) {
      val = val.replaceAll("(())")
      this.$event
        .checkMatchStr(val, { componentVariables: this.componentVariables })
        .then(res => {
          const { variables } = res
          console.log(variables)
          //有变量
          if (variables?.length) {
            variables.forEach(it => {
              const { variableName, variablePath, from } = it
              if (this.variableTagProxy[variableName]) {
                this.variableTagProxy[variableName].path = variablePath
                this.variableTagProxy[variableName].from = from
              } else {
                this.variableTagProxy[variableName] = {
                  from: from,
                  path: variablePath
                }
              }
            })
          }
        })
        .catch(err => {
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "warning",
            message: err.msg + ",已为您将错误数据保存至剪切板，请检查后重新输入"
          })
          this.copyToClip(val)
          this.$set(this.variableTagProxy[name], "matchStr", "")
        })
      // this.$set(this.variableTagProxy[name], "matchType", val)
    },
    changeWatchVariable(name, path, val) {
      if (val) {
        this.$set(this.variableTagProxy, name, {
          mode: "||",
          path,
          triggerType: "change"
        })
      } else {
        this.$delete(this.variableTagProxy, name)
      }
    }
  },
  computed: {
    variableTypeProxy: {
      get() {
        if (this.variableType === "all") {
          const res = {}
          this.componentVariables.forEach(it => (res[it.variableName] = it.variablePath))
          this.$emit("update:variableTag", res)
        }
        return this.variableType
      },
      set(val) {
        console.log("val :>> ", val)
        this.variableType = val
      }
    },
    componentVariableProxy: {
      get() {
        return this.componentVariables
      },
      set(val) {
        this.$emit("update:componentVariables", val)
      }
    },
    eventNameProxy: {
      get() {
        return this.eventName
      },
      set(val) {
        this.$emit("update:eventName", val)
      }
    }
  }
}
</script>

<style scoped>
.variable_box {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.variable_item {
  width: 33%;
}
.save_box {
  padding: 0 24px;
}
.save_edit {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 70px;
}
.save_edit:hover {
  cursor: pointer;
}
.variable-watch_item {
  border: 1px solid gray;
  border-radius: 4px;
  padding: 4px 8px;
  margin-top: 8px;
}
.variable_item_triggerType {
  display: flex;
  align-items: center;
}
::v-deep .el-switch__label {
  color: rgba(255, 255, 255, 0.4);
}
::v-deep .is-active {
  color: #409eff;
}
.select_box {
  display: flex;
  flex-direction: column;
  justify-content: right;
  align-items: center;
}
.select_box_content {
  width: 50px;
}
.variable-watch-box {
  width: 100%;
}
</style>
